import React, {useState} from 'react'

export default function TextForm(props) {

    const handleUpClick= ()=> {
        // console.log('Uppercase was clicked'+ text );
        let newText = text.toUpperCase();
        setText(newText);
        props.showAlert("Converted to Uppercase", "primary")
    };
    const handleLwClick=()=>{
        let newText = text.toLowerCase();
        setText(newText);
        props.showAlert("Converted to Lowercase", "success")
    }
    const remove=()=>{
        let newText = "";
        setText(newText);
        props.showAlert("Text cleared", "warning")
    }
    const handleCopyText=()=>{
        let text = document.getElementById('myBox');
        document.getSelection().removeAllRanges();
        text.select();
        navigator.clipboard.writeText(text.value);
        props.showAlert("Copy to clipboard", "info")
    }

    const removeExtraSpaces=()=>{
        let newText = text.split(/[ ]+/);
        setText(newText.join(' '));
        props.showAlert("Removed extra spaces", "secondary")
    }


    const handleOnChange=(e)=>{
        // console.log('On change');
        setText(e.target.value);
    }
    const [text , setText] = useState('Enter text here'); // this is important
    // text ="new text"//wrong way to set text
    //setText=("new text")//Currect way to set text

  return (
<>
    <div className='container'>
        <h1>{props.heading}</h1>
        <div className="mb-3">
        {/* style={{backgroundColor:props.mode==='dark'?'black':'white',color:props.mode==='dark'?'white':'black'}} */}
        <textarea className={`shadow-lg p-3 mb-5 bg-${props.txarea} rounded form-control border border-dark`}  style={{color:props.mode==='dark'?'white':'black'}}  value={text} onChange={handleOnChange}  id="myBox" rows="5"></textarea>
        </div>
        <button disabled={text.length===0} className="btn btn-primary mx-2 my-2" onClick={handleUpClick}>Convert to Uppercase</button>
        <button disabled={text.length===0} className="btn btn-success mx-2 my-2" onClick={handleLwClick}>Convert to Lowercase</button>
        <button disabled={text.length===0} className="btn btn-warning mx-2 my-2" onClick={remove}>Clear</button>
        <button disabled={text.length===0} className="btn btn-info mx-2 my-2" onClick={handleCopyText}>Copy Text</button>
        <button disabled={text.length===0} className="btn btn-secondary mx-2 my-2" onClick={removeExtraSpaces}>Remove Extra spaces</button>
    </div>
    <div className="container my-3">
        <h2>Your text summary</h2>
        <p>{text.split(/\s+/).filter((e)=>{return e.length!==0}).length} words and {text.length} charcters</p>
        <p>{0.008*(text.split(' ').length-1)} Minutes to read this</p>
        <p>The Number of sentence is {(text.split('.').length-1)}</p>
        <h2>Preview</h2>
        <p>{text.length>0?text:"Nothing to Preview!"}</p>
    </div>
    </>
  )
}
